import { USER_LOGGED_IN_QUERY, USER_QUERY, USER_FIRST_LOGGED_IN_QUERY, USER_REQUIRES_TERMS_ACCEPTANCE_QUERY, USER_REQUIRES_SOW_QUERY, USER_HANDLE_LOGIN, BALANCE_QUERY, ACCOUNT_PEP_BLOCK_QUERY, USER_JURISDICTION_QUERY, TRACKING_LOGOUT, USER_SET_FIRST_LOG_IN, USER_FIRST_LOG_IN_UPDATED, USER_SET_REQUIRES_TERMS_ACCEPTANCE, USER_SET_REQUIRES_SOW, USER_LOGGED_IN_UPDATED, USER_UPDATED, CLEAR_MODALS } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { isAGCO, isLOTBA, SESSION_START_TIME_KEY, INITIAL_CASH_BALANCE_KEY } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { storage } from '@gig/magic-sdk/dist/storage';
import { SessionCode } from '@gig/magic-sdk/dist/events';
import { notificationService } from '@gig/magic-messaging';

var UserSessionService = /** @class */ (function () {
    function UserSessionService() {
        this.isFirstLogIn = false;
        this.requiresTermsAcceptance = false;
        this.sowStatus = { isActionRequired: false };
        this.isUserLoggedIn = false;
        this.registerSchemas();
        this.registerUserSessionQueries();
        this.registerEventHandlers();
        this.subscribeToUserSessionChanges();
    }
    Object.defineProperty(UserSessionService.prototype, "user", {
        get: function () {
            return magic.session.getUser();
        },
        enumerable: false,
        configurable: true
    });
    UserSessionService.prototype.registerUserSessionQueries = function () {
        var _this = this;
        window.queryBus.subscribe(USER_LOGGED_IN_QUERY, function () {
            return !!_this.user;
        });
        window.queryBus.subscribe(USER_QUERY, function () {
            return _this.user;
        });
        window.queryBus.subscribe(USER_FIRST_LOGGED_IN_QUERY, function () {
            return _this.isFirstLogIn;
        });
        window.queryBus.subscribe(USER_REQUIRES_TERMS_ACCEPTANCE_QUERY, function () {
            return _this.requiresTermsAcceptance;
        });
        window.queryBus.subscribe(USER_REQUIRES_SOW_QUERY, function () {
            return _this.sowStatus;
        });
    };
    UserSessionService.prototype.registerEventHandlers = function () {
        var _this = this;
        /**
         * This handler is supposed to be called only when a successful login
         * operation is performed. On 'login' custom event
         * NOTE: this should not get triggered when a session is resumed but only
         * when and actual fresh session is started
         */
        window.eventBus.subscribe(USER_HANDLE_LOGIN, function () { return __awaiter(_this, void 0, void 0, function () {
            var jurisdiction, isPepBlocked, newBalance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        jurisdiction = _a.sent();
                        return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 2:
                        isPepBlocked = _a.sent();
                        if (isPepBlocked) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, window.queryBus.query(BALANCE_QUERY)];
                    case 3:
                        newBalance = _a.sent();
                        if (isAGCO(jurisdiction) || isLOTBA(jurisdiction)) {
                            // persist initial balance in local storage
                            storage.setItem(SESSION_START_TIME_KEY, Date.now());
                        }
                        if (isAGCO(jurisdiction)) {
                            // persist initial balance in local storage
                            storage.setItem(INITIAL_CASH_BALANCE_KEY, newBalance.balance);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    UserSessionService.prototype.subscribeToUserSessionChanges = function () {
        var _this = this;
        if (magic.session.isCreated()) {
            this.handleSessionCreated();
        }
        else {
            this.handleSessionDestroyed();
        }
        magic.events.sessionCreated(function () {
            // avoid publishing the same event twice if the session is already created
            if (_this.isUserLoggedIn) {
                return;
            }
            _this.handleSessionCreated();
        });
        magic.events.sessionDestroyed(function () {
            // avoid publishing the same event twice if the session is already destroyed
            if (!_this.isUserLoggedIn) {
                return;
            }
            _this.handleSessionDestroyed();
        });
        magic.events.sessionChange(function (code) {
            if (code !== SessionCode.LOGGED_IN) {
                window.eventBus.publish(TRACKING_LOGOUT, code);
            }
        });
        window.commandBus.subscribe(USER_SET_FIRST_LOG_IN, function (event) {
            _this.isFirstLogIn = !!event.payload;
            window.eventBus.publish(USER_FIRST_LOG_IN_UPDATED, _this.isFirstLogIn);
        });
        window.commandBus.subscribe(USER_SET_REQUIRES_TERMS_ACCEPTANCE, function (event) {
            _this.requiresTermsAcceptance = !!event.payload;
        });
        window.commandBus.subscribe(USER_SET_REQUIRES_SOW, function (event) {
            _this.sowStatus = event.payload;
        });
    };
    UserSessionService.prototype.handleSessionCreated = function () {
        this.isUserLoggedIn = true;
        window.eventBus.publish(USER_LOGGED_IN_UPDATED, true);
        window.eventBus.publish(USER_UPDATED, this.user);
        // resolving the login error promise to avoid the error modal from showing up
        Promise.resolve().then(function () {
            void magic.wsConnect();
        });
    };
    UserSessionService.prototype.handleSessionDestroyed = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isUserLoggedIn = false;
                        notificationService.closeAllNotifications();
                        return [4 /*yield*/, window.commandBus.publish(CLEAR_MODALS)];
                    case 1:
                        _a.sent();
                        window.eventBus.publish(USER_LOGGED_IN_UPDATED, false);
                        window.eventBus.publish(USER_UPDATED, this.user);
                        return [2 /*return*/];
                }
            });
        });
    };
    UserSessionService.prototype.registerSchemas = function () {
        window.eventBus.register(USER_LOGGED_IN_UPDATED, {
            type: 'boolean',
        });
        window.eventBus.register(USER_UPDATED, {
            anyOf: [
                {
                    type: 'object',
                },
                {
                    type: 'null',
                },
            ],
        });
    };
    return UserSessionService;
}());

export { UserSessionService };
